<div class="lds-ellipsis" style="margin:auto;">
    <div />
    <div />
    <div />
    <div />
</div>
